var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-form',{ref:"infoFormRefs",attrs:{"data-detail":_vm.dataDetail},on:{"submit":_vm.editEnrollment}})}
var staticRenderFns = []

export { render, staticRenderFns }